import $ from 'jquery'
import 'magnific-popup'
import Cookies from 'js-cookie'

const $closePopup = $('.js-subscribe-close')
if ($closePopup.length) {
    $closePopup[0].addEventListener('click', () => {
        Cookies.set('dismissedSubscribePopup', 1, {
            expires: 120,
            path: '/',
        })
    })
}

setTimeout(() => {
    $(document).on('mouseout', (evt) => {
        if (evt.toElement === null && evt.relatedTarget === null) {
            $(evt.currentTarget).off('mouseout')

            const newsSubscribePopup = $('#news-subscribe-popup')
            const dismissedSubscribePopup = Cookies.get(
                'dismissedSubscribePopup'
            )

            if (!dismissedSubscribePopup && newsSubscribePopup.length) {
                $.magnificPopup.open({
                    items: {
                        src: newsSubscribePopup,
                    },
                    type: 'inline',
                    preloader: true,
                    modal: true,
                    showCloseBtn: false,
                })
            }
        }
    })
}, 5000)

$('.news__subscribe #mce-success-response').bind('DOMSubtreeModified', () => {
    $('.news__subscribe').addClass('news__subscribe--submitted')
    $('#mc-embedded-subscribe').val('Thanks')
    setTimeout(() => $closePopup.click(), 5000)
})
